import React, {useState } from 'react';
import './LoginPage.css'
import SphereLogo from "../../Assets/Images/SphereLogo.png";
import axios from 'axios';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';


function LoginPage() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    // Submit the Login Form for Authentication
    const submit = (event) => {
        event.preventDefault();
        axios.post('/api/tokenLogin/', {
            username: username.toLowerCase(),
            password: password,
        })
        .then(response => {
            if (response.status === 200) {
                localStorage.setItem("user", username)
                localStorage.setItem('token', response.data['token'])
                window.location.reload();
            }
        })
        .catch(error => {
            localStorage.setItem("token", '')
            setErrorMessage("Could not login, bad username or password")
        });
    }


    // Components
    return (
        <div className="LoginPage">
            <div className='LoginPage-div'>
                <div>
                    <img src={SphereLogo} className='LoginPage-image' alt=''/>
                </div>
                <div className='LoginPage-text'>
                    <p> Sphere Audio Portal</p>
                </div>
                <Form onSubmit={submit}>
                    <Form.Group controlId="emailControlId">
                        <Form.Control className='LoginPage-textBox' value={username} onChange={e => setUsername(e.target.value)} type="text" placeholder="Email"/>
                    </Form.Group>
                    <Form.Group controlId="formBasicPassword">
                        <Form.Control className='LoginPage-textBox' value={password} onChange={e => setPassword(e.target.value)} type="password" placeholder="Password"/>
                    </Form.Group>
                    <div>
                    <Button variant="primary" className='LoginPage-Submit' type="submit">Submit</Button>
                    </div>
                    <Form.Text className='LoginPage-errorText'>{errorMessage}</Form.Text>
                </Form>
            </div>
        </div>
    )
}


export default LoginPage
